import React from 'react';
import { Dialog, DialogTitle, DialogActions, Button, DialogContent, Typography, Box } from '@mui/material';

interface ConfirmDeleteModalProps {
    open: boolean;
    onClose: () => void;
    name?: any;
    message: any;
    /** Título opcional. Si no se entrega, se usa el comportamiento por defecto ("Error"). */
    title?: string;
    /** Severidad opcional para colorear el modal. Por defecto "error" (retrocompatible). */
    severity?: 'error' | 'success' | 'warning';
}

const ConfirmDeleteModal: React.FC<ConfirmDeleteModalProps> = ({ open, onClose, name, message, title, severity = 'error' }) => {

    // Color según severidad (mantiene "error.main" por defecto)
    const color = severity === 'success' ? 'success.main'
        : severity === 'warning' ? 'warning.main'
        : 'error.main';

    const buttonColor = severity === 'success' ? 'success'
        : severity === 'warning' ? 'warning'
        : 'error';

    const renderTitle = () => {
        if (title) return title;
        return name ? `Error - ${name}` : `Error`;
    }

    const renderMessage = () => {
        if (!message) return null;
        const msgString = String(message);

        return (
            <Box sx={{ mt: 1 }}>
                {msgString.split('\n').map((line, index) => {
                    const isBullet = line.trim().startsWith('•');
                    const isHeader = line.includes('Se importaron') || line.includes('errores:') || line.includes('importado');

                    return (
                        <Typography
                            key={index}
                            variant="body1"
                            sx={{
                                mb: isBullet ? 0.5 : 2,
                                ml: isBullet ? 2 : 0,
                                fontWeight: isHeader ? 'bold' : 'normal'
                            }}
                        >
                            {line}
                        </Typography>
                    );
                })}
            </Box>
        );
    }

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ fontWeight: 'bold', color: color }}>
                {renderTitle()}
            </DialogTitle>
            <DialogContent dividers>
                {renderMessage()}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color={buttonColor as any} variant="contained">
                    Cerrar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDeleteModal;
